<template>
  <div class="wrapper w-100">
    <el-row :gutter="18">
      <el-col :span="9"><b>Received At:</b></el-col>
      <el-col :span="9">{{getReceivedAt}}</el-col>
    </el-row>
    <el-row :gutter="18" v-for="(value, key) in items" :key="getKey(key)">
      <div v-if="hasSubData(value)">
        <div class="font-weight-bold text-uppercase" style="padding-left: 9px; padding-right: 9px;">
          {{key}}
        </div>
        <div v-for="(subValue, subKey) in value" :key="getKey(subKey)">
          <el-col :span="9"><b>{{subKey}}</b></el-col>
          <el-col :span="9">{{subValue || '---'}}</el-col>
        </div>
      </div>
      <div v-else>
        <el-col :span="9"><b>{{key}}</b></el-col>
        <el-col :span="9">{{value || '---'}}</el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    items: Object,
    receivedAt: Object,
  },

  computed: {
    /**
     * @return {null|string}
     */
    getReceivedAt() {
      return _.isNull(this.receivedAt)
        ? null
        : moment(_.get(this.receivedAt, 'datetime')).format(config('format.moment.short.datetime'));
    },
  },

  methods: {
    /**
     * @param item
     * @return {boolean}
     */
    hasSubData(item) {
      return _.isObject(item);
    },

    /**
     * @return {string}
     */
    getKey(name) {
      return _.camelCase(name);
    },
  },
}
</script>

<style scoped>

</style>
